import request from '@/utils/request';

export function getStyleList() {
  return request({
    url: '/sc-basic-merchant-backend/stage/rule/style/enum',
  })
}

export function getRuleTypeList() {
  return request({
    url: '/sc-basic-merchant-backend/stage/rule/rule/type/enum',
  })
}

export function editStageRule(data) {
  return request({
    url: '/sc-basic-merchant-backend/stage/rule/edit',
    method: 'post',
    data,
  })
}

export function getStageRule(params) {
  return request({
    url: '/sc-basic-merchant-backend/stage/rule/list/rule',
    params,
  })
}

